import {Form} from 'antd'
import {useRunWorkflow} from '@/biz/workflow.jsx'
import http from '@/biz/http.mjs'
import {FilePicker, TextArea} from '@/components/Form/index.mjs'
import {Prompt, useOpenModal} from '@/components/Modal/index.mjs'
import runAsync from '@/script/runAsync.mjs'

export const aiGenerateReqDoc = () => () => {
    const openModal = useOpenModal()
    const runWorkflow = useRunWorkflow()

    return async function () {
        const {prjId, prjPatternId, rev, sVer, prjName, prjNo} = this.data

        const validate = values => {
            const {files, userMessage} = values

            if (! (userMessage || 0 < files?.length)) {
                throw new Error('必须上传模板文件或输入提示词')
            }
        }

        const inputs = await openModal(
            <Prompt
                title="提供模板"
                validate={validate}
            >
                <Form.Item
                    label="模板"
                    name="files"
                >
                    <FilePicker
                        limit={1}

                        types={[{
                            description: 'Microsoft Word',

                            accept: {
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
                            },
                        }]}
                    />
                </Form.Item>

                <Form.Item
                    label="提示词"
                    name="userMessage"
                >
                    <TextArea />
                </Form.Item>
            </Prompt>
        )

        if (! inputs) {
            return
        }

        const {files = [], userMessage} = inputs

        const remoteFiles = await runAsync(
            () => Promise.all(files.map(
                file => http.upload({file, pathName: 'tmp'})
            )),

            {action: '上传文件'}
        )

        const fileIds = remoteFiles.map(f => f.id)

        const bizMap = {
            files: fileIds,
            prjId,
            patternId: prjPatternId,
            rev,
            sVer,
            userMessage,
            prjName,
            prjNo
        }

        runWorkflow({bizMap, scene: 'GENERATE_SRS'})
    }
}
